module.exports = __webpack_public_path__ + "static/media/details-24-image-6.7da5f2a2.jpg";